import { BlaestProduct } from "@/formatters/types";

export const getCanonicalCategory = (
  product: BlaestProduct,
): string | undefined => {
  try {
    const canonical =
      (product?.categoryName &&
        product?.categoryName?.length > 0 &&
        product?.categoryName[0]) ||
      "";
    if (!canonical) throw new Error("No canonical category found");
    return canonical;
  } catch {
    return undefined;
  }
};
